/**
 * Standard parameter names for gamepad commands
 */
export const GamepadCommandParams = {
  SEND_TIME_MS: 'gamepadSendTimeMs',
} as const;

export type GamepadCommandParamKey = typeof GamepadCommandParams[keyof typeof GamepadCommandParams];

export interface CommandParams {
  [key: string]: string;
}

/**
 * Returns current timestamp in milliseconds as a string
 */
export const getCurrentTimestampMs = (): string => {
  return String(Date.now());
};

/**
 * Adds gamepad send timestamp to command parameters
 */
export const addGamepadTimestamp = (commandParams: CommandParams): CommandParams => {
  commandParams[GamepadCommandParams.SEND_TIME_MS] = getCurrentTimestampMs();
  return commandParams;
};
